import React from "react"
import { Container } from "reactstrap"

const Unauthorized = () => {

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <h3>
                        Unauthorized
                    </h3>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Unauthorized